<template>
  <section>
    <HeadingSmall>
      {{ $options.title }}
    </HeadingSmall>
    <ul class="jc-clearlist">
      <li
        :class="$style.option"
      >
        <Checkbox
          v-model="needsLowercase"
          data-test-id="passwordNeedsLowercase"
          :label="$options.labels.needsLowercase"
        />
      </li>
      <li
        :class="$style.option"
      >
        <Checkbox
          v-model="needsUppercase"
          data-test-id="passwordNeedsUppercase"
          :label="$options.labels.needsUppercase"
        />
      </li>
      <li
        :class="$style.option"
      >
        <Checkbox
          v-model="needsNumeric"
          data-test-id="passwordNeedsNumeric"
          :label="$options.labels.needsNumeric"
        />
      </li>
      <li
        :class="$style.option"
      >
        <Checkbox
          v-model="needsSymbolic"
          data-test-id="passwordNeedsSymbolic"
          :label="$options.labels.needsSymbolic"
        />
      </li>
    </ul>
  </section>
</template>

<script>
import { Checkbox, HeadingSmall } from '@jumpcloud/ui-components';
import createComputedObjectBinding from 'client/util/createComputedObjectBinding';

const title = 'Password Complexity';
const labels = {
  needsLowercase: 'Password must include a lowercase letter',
  needsUppercase: 'Password must include an uppercase letter',
  needsNumeric: 'Password must include a number',
  needsSymbolic: 'Password must include a special character',
};

export default {
  name: 'FieldsPasswordComplexity',

  components: {
    Checkbox,
    HeadingSmall,
  },

  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    needsLowercase: {
      ...createComputedObjectBinding('needsLowercase'),
    },
    needsNumeric: {
      ...createComputedObjectBinding('needsNumeric'),
    },
    needsSymbolic: {
      ...createComputedObjectBinding('needsSymbolic'),
    },
    needsUppercase: {
      ...createComputedObjectBinding('needsUppercase'),
    },
  },

  title,
  labels,
};
</script>

<style module>
@import '../settings.css';
</style>
